module.exports = __webpack_public_path__ + "img/c06_unitpalintonon_Normal_ua.8f336d7e.webp";